import Component from '@bythepixel/component-loader';
import SectionTabs from '@Core/components/sectionTabs';

export default class TypesTabs extends Component {
  static selector = '[data-comp-types-tabs]';

  constructor(containerEl) {
    super(containerEl);

    /* eslint-disable no-new */
    new SectionTabs(containerEl);
  }
}
